import React, { useEffect, useMemo, useState } from "react";
import {
  FashBusinesses,
  SignedUpBusinesses,
  StyleCategories,
} from "../../pages";
import { BusinessController, FashCreativesController } from "../../controllers";
import { fashCreativeStore, useStores } from "../../stores";
import { useNavigate } from "react-router-dom";
import constant from "../../utils/constant";
import { toJS } from "mobx";

const StyleCategoriesContainer = () => {
  const [ViewMoreModal, setViewMoreModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updateCategoryModal, setUpdateCategoryModal] = useState(false);

  useEffect(() => {
    const fetchStyleCategories = async () => {
      setLoading(true);
      await FashCreativesController.getStyleCategories();
      setLoading(false);
    };

    fetchStyleCategories();
  }, []);

  const options = [
    {
      label: "Update Category",
      value: "Update Category",
    },
  ];

  const handleUpdate = () => {
    setUpdateCategoryModal(true);
  };

  const closeModal = () => {
    setUpdateCategoryModal(false);
  };

  return (
    <StyleCategories
      styleCategories={toJS(fashCreativeStore.categories)}
      closeModal={closeModal}
      updateCategoryModal={updateCategoryModal}
      handleUpdate={handleUpdate}
      options={options}
      loading={loading}
    />
  );
};
export default StyleCategoriesContainer;
